import React from "react";
import { InstructionAlert } from "./InstructionAlert";

export function HistoricalFileImportNotice({
  dataSourceName,
}: {
  dataSourceName: string;
}): React.ReactElement {
  return (
    <InstructionAlert type="info">
      {dataSourceName} is no longer operating. However, you can still import
      historical files if you have a copy.
    </InstructionAlert>
  );
}
